
import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'
import {
  computed,
  defineComponent,
  nextTick,
  onUnmounted,
  ref,
  watch,
  WatchStopHandle
} from 'vue'

export default defineComponent({
  name: 'Carousel',
  props: {
    keyMap: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default() {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default(): any[] {
        return [] as any[]
      }
    },
    showPage: {
      type: Boolean,
      default: true
    }
  },
  setup(props: Record<string, any>) {
    const swiperRef = ref<HTMLDivElement | null>(null)
    let swiperInstance: null | Record<string, any> = null
    const progress = ref(0)
    // eslint-disable-next-line vue/no-setup-props-destructure
    const len = computed(() => props.data.length)
    const changeProgress = ({ realIndex }: any) => {
      progress.value = (realIndex + 1) / len.value
    }
    if (!props.options.loop) {
      progress.value = 1 / len.value
    }
    const options = computed(() => {
      const options = { ...props.options }
      if (props.showPage) {
        options.on || (options.on = {})
        options.on.slideChange = changeProgress
      }
      return options
    })
    let unwatchDataAndOpt: WatchStopHandle | null = null
    watch(
      () => [props.disabled],
      () => {
        if (!props.disabled) {
          unwatchDataAndOpt = watch(
            () => [options, props.data],
            () => {
              swiperInstance?.destroy(true, true)
              nextTick(() => {
                if (props.data.length > 1) {
                  progress.value = 1 / props.data.length
                  swiperRef.value &&
                    (swiperInstance = new Swiper(
                      swiperRef.value,
                      options.value
                    ))
                }
              })
            },
            {
              immediate: true
            }
          )
        } else {
          unwatchDataAndOpt && unwatchDataAndOpt()
        }
      },
      { immediate: true }
    )
    onUnmounted(() => {
      swiperInstance?.destroy(true, true)
    })
    return {
      feedbackTap(e: MouseEvent) {
        if (props.disabled || props.data.length === 1) {
          let on = props.options.on
          if (on) {
            let el = e.target as any
            while (!el || el.className !== 'swiper-slide') {
              el = el.parentElement
            }
            on.tap({ realIndex: 0, clickedSlide: el || null })
          }
        }
      },
      swiperRef,
      progress
    }
  }
})
